import React from 'react';

interface Close1IconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const CloseIcon1 = ({ width = 24, height = 24 }: Close1IconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18M6 6L18 18" stroke="#B2B3B5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default CloseIcon1;
